export { Icon, type IconProps } from './Icon';
export { iconNames, type IconName } from './names';
